import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AgmCoreModule } from '@agm/core';
import { AgmSnazzyInfoWindowModule } from '@agm/snazzy-info-window';
import { CategoriesListComponent } from '@app/codebase/category/categories-list/categories-list.component';
import { CommonModule } from '@angular/common';
import { CompleteYourProfileComponent } from '@app/shared/complete-your-profile/complete-your-profile.component';
import { EmptyStateComponent } from '@app/codebase/empty-state/empty-state.component';
import { FavoriteListingsHorizontalComponent } from './favorite-listings-horizontal/favorite-listings-horizontal.component';
import { FeaturedEventsRowComponent } from './featured-events-row/featured-events-row.component';
import { GenericAlertComponent } from './generic-alert/generic-alert.component';
import { AdAlertComponent } from './ad-alert/ad-alert.component';
import { IonicModule } from '@ionic/angular';
import { IonicRatingModule } from 'ionic4-rating';
import { ListingCellComponent } from './listing-cell/listing-cell.component';
import { ListingCellTntComponent } from './listing-cell-tnt/listing-cell-tnt.component';
import { ListingsMapComponent } from '@app/codebase/listings/listings-map/listings-map.component';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedComponent } from './shared.component';
import { UserSearchInboxHeaderComponent } from './user-search-inbox-header/user-search-inbox-header.component';
import { WebViewComponent } from './web-view/web-view.component';
import { environment } from '@env/environment';
import { MainTopBarV2Component } from './main-top-bar-v2/main-top-bar-v2.component';
import { LikedListingsComponent } from '@app/codebase/itineraries/liked-listings/liked-listings.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { createTranslateLoader } from '@app/app.module';
import { HttpClient } from '@angular/common/http';
import { VenuesPage } from '@app/passport/venues/venues.page';
import { BackButtonDirective } from '@app/directives/back-button.directive';
import { FavoriteListingsComponent } from '@app/codebase/itinerariesv2/favorite-listings/favorite-listings.component';
import { ChooseDateComponent } from '@app/codebase/itinerariesv2/choose-date/choose-date.component';
import { ItineraryDetailsComponent } from '@app/codebase/itineraries/itinerary-details/itinerary-details.component';
import { ItineraryDayCellComponent } from '@app/codebase/itineraries/itinerary-details/itinerary-day-cell/itinerary-day-cell.component';
import { StopCellComponent } from '@app/codebase/itineraries/itinerary-details/stop-cell/stop-cell.component';
import { CreateItineraryComponent } from '@app/codebase/itinerariesv2/create-itinerary/create-itinerary.component';
import { ChangeRegionRowComponent } from './change-region-row/change-region-row.component';
import { AdvertisementsComponent } from './advertisements/advertisements.component';
import { ChunkPipe } from '@app/chunk.pipe';
import { TabsHomeWidgetComponent } from './tabs-home-widget/tabs-home-widget.component';
import { RegionsTabComponent } from './tabs-home-widget/regions-tab/regions-tab.component';
import { TrailsTabComponent } from './tabs-home-widget/trails-tab/trails-tab.component';
import { DeleteProfileComponent } from '@app/codebase/me-tnt/settings/delete-profile/delete-profile.component';
import { ConfirmDeleteComponent } from '@app/codebase/me-tnt/settings/confirm-delete/confirm-delete.component';
import { AgmJsMarkerClustererModule } from '@agm/js-marker-clusterer';
import { RegionChildrensComponent } from '@app/codebase/regions/region-childrens/region-childrens.component';
import { LanguagePopoverComponent } from './language-popover/language-popover.component';
import { TrailsMapComponent } from '@app/codebase/trails/trails-map/trails-map.component';
import { InitialpopupComponent } from '@app/codebase/scavenger-hunts/initialpopup/initialpopup.component';
import { WelcomeToScavengerHuntsComponent } from '@app/codebase/scavenger-hunts/welcome-to-scavenger-hunts/welcome-to-scavenger-hunts.component';
import { ScavengerHuntsMapComponent } from '@app/codebase/scavenger-hunts/scavenger-hunts-map/scavenger-hunts-map.component';
import { TrailMapCheckinComponent } from '@app/codebase/list-details/trail-map-checkin/trail-map-checkin.component';
import { TrailCompletedComponent } from '@app/codebase/scavenger-hunts/trail-completed/trail-completed.component';
import { BeerOMeterComponent } from "@app/codebase/scavenger-hunts/beer-o-meter/beer-o-meter.component";
import { ApplicationWidgetComponent } from './application-widget/application-widget.component';
import { ModalFormComponent } from './modal-form/modal-form.component';
import { ModalSuccessComponent } from './modal-success/modal-success.component';
import { IaAvatarComponent } from './ia-avatar/ia-avatar.component';
import { PermissionComponent } from './permission/permission.component';
//import { NgxQrcodeStylingModule } from 'ngx-qrcode-styling';
import { ModalReservationComponent } from '@app/codebase/checkin/modal-reservation/modal-reservation.component';
import { ParkingComponent } from '@app/codebase/checkin/parking/parking.component';
import { QrCodeComponent } from './qr-code/qr-code.component';
import { ModalDataReservationComponent } from '@app/codebase/checkin/modal-data-reservation/modal-data-reservation.component';
import { ModalSuccessReservationComponent } from '@app/codebase/checkin/modal-success-reservation/modal-success-reservation.component';
import { ModalAddguestComponent } from '@app/codebase/checkin/modal-addguest/modal-addguest.component';
import { CheckinPageModule } from '@app/codebase/checkin/checkin.module';
import { WifiinformationComponent } from './wifiinformation/wifiinformation.component';
import { RoommapdetailComponent } from './roommap/roommapdetail/roommapdetail.component';
import { TrainmapComponent } from '@app/codebase/checkin/trainmap/trainmap.component';
import { SuccessCheckoutComponent } from '@app/codebase/checkout/success-checkout/success-checkout.component';
import { ModalInstructionsComponent } from '@app/codebase/roommap/modal-instructions/modal-instructions.component';
import { UpgradeRoomPage } from '@app/codebase/welcome-checkin/upgrade-room/upgrade-room.page';
import { UpgradeRoomDetailsComponent } from '@app/codebase/sign-up/welcome-checkin/upgrade-room-details/upgrade-room-details.component';
import { QrcodePage } from '@app/codebase/qrcode/qrcode.page';
import { ModalChargesComponent } from '@app/codebase/checkin/modal-charges/modal-charges.component';
import { ModalRoomsComponent } from '@app/codebase/checkin/modal-rooms/modal-rooms.component';
import { MyroomComponent } from '@app/codebase/checkin/myroom/myroom.component';
import { CardsComponent } from '@app/codebase/cards/cards.component';
import { PopupComponent } from '@app/codebase/popup/popup.component';
import { PopupPrearrivalComponent } from '@app/codebase/popup-prearrival/popup-prearrival.component';
import { PrearrivalCheckinComponent } from '@app/codebase/prearrival-checkin/prearrival-checkin.component';
import { PopupMessageComponent } from '@app/codebase/popup-message/popup-message.component';
import { ModalLateChargesComponent } from '@app/codebase/checkin/modal-late-charges/modal-late-charges.component';
import { PaymentSuccessfulPopupComponent } from '@app/codebase/checkin/payment-successful-popup/payment-successful-popup.component';
import { EarlyCheckinPopupComponent } from '@app/codebase/checkin/early-checkin-popup/early-checkin-popup.component';
import { ScanidComponent } from '@app/codebase/checkin/scanid/scanid.component';
import { RoommanagerComponent } from '@app/codebase/checkin/roommanager/roommanager.component';
import { SignatureComponent } from '@app/shared/signature/signature.component';
import { PopupUpdateComponent } from '@app/codebase/popup-update/popup-update.component';
import { GenericmodalComponent } from '@app/codebase/prearrival/genericmodal/genericmodal.component';

@NgModule({
  imports: [
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    CommonModule,
    //NgxQrcodeStylingModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    RouterModule,
    AgmCoreModule.forRoot({
      apiKey: environment.googleMaps,
      libraries: ['geometry']
    }),
    AgmJsMarkerClustererModule,
    AgmSnazzyInfoWindowModule,
    IonicRatingModule,
  ],
  declarations: [
    QrcodePage,
    BackButtonDirective,
    SharedComponent,
    UserSearchInboxHeaderComponent,
    MainTopBarV2Component,
    GenericAlertComponent,
    AdAlertComponent,
    ListingsMapComponent,
    ListingCellComponent,
    LikedListingsComponent,
    FavoriteListingsComponent,
    ChooseDateComponent,
    ItineraryDetailsComponent,
    ItineraryDayCellComponent,
    StopCellComponent,
    CreateItineraryComponent,
    ListingCellTntComponent,
    TrailsMapComponent,
    FeaturedEventsRowComponent,
    ChangeRegionRowComponent,
    RegionChildrensComponent,
    TabsHomeWidgetComponent,
    RegionsTabComponent,
    TrailsTabComponent,
    FavoriteListingsHorizontalComponent,
    WebViewComponent,
    AdvertisementsComponent,
    EmptyStateComponent,
    ChunkPipe,
    VenuesPage,
    CategoriesListComponent,
    CompleteYourProfileComponent,
    DeleteProfileComponent,
    ConfirmDeleteComponent,
    LanguagePopoverComponent,
    IaAvatarComponent,
    BeerOMeterComponent,
    WelcomeToScavengerHuntsComponent,
    ScavengerHuntsMapComponent,
    TrailMapCheckinComponent,
    TrailCompletedComponent,
    InitialpopupComponent,
    ApplicationWidgetComponent,
    ModalFormComponent,
    ModalSuccessComponent,
    PermissionComponent,
    SuccessCheckoutComponent,
    ModalReservationComponent,
    ModalDataReservationComponent,
    ModalSuccessReservationComponent,
    ModalChargesComponent,
    ModalRoomsComponent,
    ModalAddguestComponent,
    ParkingComponent,
    MyroomComponent,
    //IaAvatarComponent,
    // QrCodeComponent,
    ListingsMapComponent,
    ListingCellComponent,
    LikedListingsComponent,
    FavoriteListingsComponent,
    ChooseDateComponent,
    ItineraryDetailsComponent,
    ItineraryDayCellComponent,
    StopCellComponent,
    CreateItineraryComponent,
    ListingCellTntComponent,
    FeaturedEventsRowComponent,
    FavoriteListingsHorizontalComponent,
    WebViewComponent,
    EmptyStateComponent,
    VenuesPage,
    CategoriesListComponent,
    CompleteYourProfileComponent,
    CardsComponent,
    PopupComponent,
    PopupPrearrivalComponent,
    PopupUpdateComponent,
    PopupMessageComponent,
    GenericmodalComponent,
    PrearrivalCheckinComponent,
    ModalLateChargesComponent,
    PaymentSuccessfulPopupComponent,
    EarlyCheckinPopupComponent,
    ScanidComponent,
    RoommanagerComponent,
    SignatureComponent
  ],
  exports: [
    QrcodePage,
    SharedComponent,
    UserSearchInboxHeaderComponent,
    MainTopBarV2Component,
    GenericAlertComponent,
    AdAlertComponent,
    ListingsMapComponent,
    LikedListingsComponent,
    FavoriteListingsComponent,
    ChooseDateComponent,
    ItineraryDetailsComponent,
    ItineraryDayCellComponent,
    StopCellComponent,
    CreateItineraryComponent,
    ListingCellComponent,
    ListingCellTntComponent,
    FeaturedEventsRowComponent,
    ChangeRegionRowComponent,
    RegionChildrensComponent,
    TabsHomeWidgetComponent,
    RegionsTabComponent,
    TrailsTabComponent,
    FavoriteListingsHorizontalComponent,
    WebViewComponent,
    EmptyStateComponent,
    ChunkPipe,
    AdvertisementsComponent,
    TrailsMapComponent,
    VenuesPage,
    CategoriesListComponent,
    DeleteProfileComponent,
    ConfirmDeleteComponent,
    LanguagePopoverComponent,
    IaAvatarComponent,
    BeerOMeterComponent,
    WelcomeToScavengerHuntsComponent,
    ScavengerHuntsMapComponent,
    TrailMapCheckinComponent,
    TrailCompletedComponent,
    InitialpopupComponent,
    ApplicationWidgetComponent,
    ModalFormComponent,
    ModalSuccessComponent,
    PermissionComponent,
    CardsComponent,
    PopupComponent,
    PopupPrearrivalComponent,
    PopupUpdateComponent,
    PopupMessageComponent,
    GenericmodalComponent,
    PrearrivalCheckinComponent,
    ModalLateChargesComponent,
    PaymentSuccessfulPopupComponent,
    EarlyCheckinPopupComponent,
    ScanidComponent,
    RoommanagerComponent,
    SignatureComponent
],
  entryComponents: [
    QrcodePage,
    GenericAlertComponent,
    AdAlertComponent,
    VenuesPage,
    LikedListingsComponent,
    FavoriteListingsComponent,
    ChooseDateComponent,
    ItineraryDetailsComponent,
    ItineraryDayCellComponent,
    StopCellComponent,
    CreateItineraryComponent,
    CompleteYourProfileComponent,
    DeleteProfileComponent,
    ConfirmDeleteComponent,
    LanguagePopoverComponent,
    IaAvatarComponent,
    BeerOMeterComponent,
    WelcomeToScavengerHuntsComponent,
    ScavengerHuntsMapComponent,
    TrailMapCheckinComponent,
    TrailCompletedComponent,
    InitialpopupComponent,
    ApplicationWidgetComponent,
    ModalFormComponent,
    ModalSuccessComponent,
    PermissionComponent,
    CardsComponent,
    PopupComponent,
    PopupPrearrivalComponent,
    PopupUpdateComponent,
    PopupMessageComponent,
    GenericmodalComponent,
    PrearrivalCheckinComponent,
    ModalLateChargesComponent,
    PaymentSuccessfulPopupComponent,
    EarlyCheckinPopupComponent,
    ScanidComponent,
    RoommanagerComponent,
    SignatureComponent
]
})
export class SharedComponentModule { }
